<template>
  <router-view />
</template>

<script>
export default {
  name: 'AssignLoanOfficerOldClient'
}
</script>

<style scoped>

</style>
